import React from "react";
import { useState } from "react";

export function SamataRow({ it, idx, priceMode, kainininkai, onChange, onDel }) {
          const [editing, setEditing] = useState(false);
          const price = priceMode === 'client' ? (parseFloat(it.clientPrice)||0) : (parseFloat(it.personalPrice)||0);
          const disc = parseFloat(it.discount)||0;
          const discPrice = price * (1 - disc/100);
          const suma = discPrice * (parseFloat(it.qty)||0);
          const inp = {border:'1px solid #e5e7eb',borderRadius:4,padding:'3px 5px',fontSize:11,width:'100%',boxSizing:'border-box'};

          if (editing) {
            return (
              <tr style={{background:'#f0f9ff',borderBottom:'1px solid #e5e7eb'}}>
                <td style={{padding:'6px 4px',textAlign:'center',color:'#9ca3af',fontSize:10}}>{idx+1}</td>
                <td style={{padding:'6px 8px'}}><input style={inp} value={it.gamintojas||''} onChange={e=>onChange('gamintojas',e.target.value)} placeholder="Gamintojas"/></td>
                <td style={{padding:'6px 8px'}}><input style={inp} value={it.name} onChange={e=>onChange('name',e.target.value)} placeholder="Pavadinimas"/></td>
                <td style={{padding:'6px 4px'}}><input style={{...inp,width:40}} value={it.unit} onChange={e=>onChange('unit',e.target.value)}/></td>
                <td style={{padding:'6px 8px'}}><input style={inp} type="number" value={it.qty} onChange={e=>onChange('qty',e.target.value)}/></td>
                <td style={{padding:'6px 8px'}}>
                  <input style={inp} type="number" step="0.01"
                    value={priceMode==='client'?(it.clientPrice||''):(it.personalPrice||'')}
                    onChange={e=>onChange(priceMode==='client'?'clientPrice':'personalPrice',e.target.value)}/>
                </td>
                <td style={{padding:'6px 8px'}}>
                  <input style={inp} type="number" step="0.1" min="0" max="100"
                    value={it.discount||''} onChange={e=>onChange('discount',e.target.value)} placeholder="0"/>
                </td>
                <td style={{padding:'6px 8px',textAlign:'right',color:'#059669',fontWeight:600}}>{discPrice.toFixed(2)} €</td>
                <td style={{padding:'6px 8px',textAlign:'right',fontWeight:700}}>{suma.toFixed(2)} €</td>
                <td style={{padding:'6px 4px'}}><button onClick={()=>setEditing(false)} style={{background:'#383853',color:'#fff',border:'none',borderRadius:4,padding:'3px 7px',fontSize:11,cursor:'pointer'}}>✓</button></td>
              </tr>
            );
          }
          return (
            <tr style={{background:idx%2===0?'#fff':'#fafafa',borderBottom:'1px solid #f0f0f0'}} onDoubleClick={()=>setEditing(true)}>
              <td style={{padding:'6px 4px',textAlign:'center',color:'#9ca3af',fontSize:10}}>{idx+1}</td>
              <td style={{padding:'6px 8px',color:'#6b7280'}}>{it.gamintojas||<span style={{color:'#ccc'}}>—</span>}</td>
              <td style={{padding:'6px 8px',fontWeight:600,color:'#1c1c1c'}}>{it.name||<span style={{color:'#ccc'}}>—</span>}</td>
              <td style={{padding:'6px 4px',textAlign:'center',color:'#6b7280'}}>{it.unit}</td>
              <td style={{padding:'6px 8px',textAlign:'right'}}>{it.qty}</td>
              <td style={{padding:'6px 8px',textAlign:'right',fontWeight:600}}>{price.toFixed(2)} €</td>
              <td style={{padding:'6px 8px',textAlign:'right',color:disc>0?'#ea580c':'#9ca3af'}}>{disc>0?`${disc}%`:'—'}</td>
              <td style={{padding:'6px 8px',textAlign:'right',fontWeight:600,color:'#059669'}}>{discPrice.toFixed(2)} €</td>
              <td style={{padding:'6px 8px',textAlign:'right',fontWeight:700,color:'#383853'}}>{suma.toFixed(2)} €</td>
              <td style={{padding:'6px 4px',textAlign:'center'}}>
                <div style={{display:'flex',gap:3}}>
                  <button onClick={()=>setEditing(true)} style={{background:'none',border:'none',color:'#9ca3af',cursor:'pointer',fontSize:13}}>✏</button>
                  <button onClick={onDel} style={{background:'none',border:'none',color:'#d1d5db',cursor:'pointer',fontSize:15}}>×</button>
                </div>
              </td>
            </tr>
          );
        }
